import { getLanguage } from 'shared/helper/link-helper';
import { storage } from 'shared/helper/storage';
window.dataLayer = window.dataLayer || [];
export var recordUrl = function recordUrl(url) {
  var urlWithoutLanguage = url.replace(/(cn|jp|en|br|es)\//, '');

  // For urls like /researcher, log it as /en/researcher to ensure the language arrives.
  window.dataLayer.push({
    AdjustedLanguageURL: "/".concat(getLanguage(url)).concat(urlWithoutLanguage)
  });
};
export var recordUser = function recordUser(user) {
  if (user) {
    window.dataLayer.push({
      Authenticated: 'Logged In'
    });
    window.dataLayer.push({
      UUID: user.gtmUid
    });
    window.dataLayer.push({
      RSUID: user.id
    });
    window.dataLayer.push({
      customerId: user.identity
    });
    window.dataLayer.push({
      dlCustomerId: user.identity
    });
    window.dataLayer.push({
      userEmail: user.email
    });
  } else {
    window.dataLayer.push({
      Authenticated: 'Not Logged In'
    });
  }
};
export var recordNumberOfOrders = function recordNumberOfOrders(numberOfOrders) {
  window.dataLayer.push({
    Subs: numberOfOrders
  });
};
export var recordTransaction = function recordTransaction(_ref) {
  var identifier = _ref.identifier,
    total = _ref.total,
    products = _ref.products,
    affiliation = _ref.affiliation;
  // We _only_ want to emit this set of events once per session
  var storageKey = "recordDigitalServicesTransaction".concat(identifier);
  if (storage.get(storageKey)) {
    return;
  }
  window.dataLayer.push({
    event: 'trackTrans',
    dlTransactionId: identifier,
    dlTransactionTotal: total,
    // These are used via GA ecommerce. See https://support.google.com/tagmanager/answer/6107169
    transactionId: identifier,
    transactionTotal: total,
    transactionProducts: products,
    transactionAffiliation: affiliation // companyShortName
  });
};
export var recordOrderCompletion = function recordOrderCompletion(order) {
  if (!order) {
    return;
  }

  // We _only_ want to emit this set of events once per session
  var storageKey = "recordOrderCompletion".concat(order.externalId);
  if (storage.get(storageKey)) {
    return;
  }
  var items = order.items,
    products = order.products,
    skus = order.skus;
  recordTransaction({
    identifier: order.externalId,
    products: items || [],
    total: order.usdAmount,
    affiliation: order.user.companyShortName
  });
  window.dataLayer.push({
    event: 'submission-complete',
    dlCurrency: 'USD',
    dlCustomerId: order.user.identity,
    dlOrderId: order.receiptCode,
    dlRevenue: order.usdAmount,
    dlTransactionId: order.externalId,
    // These variables don't appear to be used by GTM
    dlProducts: products || '',
    // list of service names (separated by |)
    dlSkus: skus || '',
    // list of service skus (separated by |)
    dlAos: order.areaOfStudy,
    dlDiscount: order.discountAmount,
    dlCouponCodes: order.promotionalCodes,
    // promotional codes (separated by |)
    dlCity: order.invoiceAddress.city || '',
    dlState: order.invoiceAddress.state || '',
    dlZip: order.invoiceAddress.zip || '',
    dlCountry: order.invoiceAddress.countryIso || ''
  });
  storage.set(storageKey, true);
};
export var recordWordCountNoticeInteraction = function recordWordCountNoticeInteraction(wordCountChangedManually, userIdentity) {
  var userChangedWordBin = wordCountChangedManually ? 'changed' : 'ignored';
  window.dataLayer.push({
    event: 'wordCountResponse',
    dlCustomerId: userIdentity,
    wordCountChanged: userChangedWordBin
  });
};
var recordGenericEvent = function recordGenericEvent(_ref2) {
  var eventCategory = _ref2.eventCategory,
    eventAction = _ref2.eventAction,
    eventLabel = _ref2.eventLabel;
  return window.dataLayer.push({
    event: 'analyticsEvent',
    eventAction: eventAction,
    eventCategory: eventCategory,
    eventLabel: eventLabel
  });
};
export var recordSkipUploadFirstEvent = function recordSkipUploadFirstEvent(eventLabel) {
  return recordGenericEvent({
    eventAction: 'Skip upload-first',
    eventCategory: 'Selection',
    eventLabel: eventLabel
  });
};
export var recordLanguageAssessmentScoreCompletion = function recordLanguageAssessmentScoreCompletion() {
  return window.dataLayer.push({
    event: 'grammarCheckResultAvailable'
  });
};